import { Map as ImmutableMap } from 'immutable';
import { INITIALIZE_FAKE_UNDOABLE_ITEMS, UPDATE_FAKE_UNDOABLE_ITEMS } from 'ContentEditorUI/redux/actions/actionTypes';
import produce from 'immer';
const initialStateAsJSObject = {
  initialized: false,
  items: {}
};
const initialState = ImmutableMap({
  initialized: false,
  items: ImmutableMap()
});
export const fakeUndoableReducerAsJSObject = (state = initialStateAsJSObject, action) => produce(state, draft => {
  switch (action.type) {
    case INITIALIZE_FAKE_UNDOABLE_ITEMS:
      return {
        initialized: true,
        items: action.items
      };
    case UPDATE_FAKE_UNDOABLE_ITEMS:
      {
        const items = draft.items;
        Object.assign(items, action.items);
        return draft;
      }
    default:
      return draft;
  }
});
const fakeUndoableReducer = (state = initialState, action) => {
  switch (action.type) {
    case INITIALIZE_FAKE_UNDOABLE_ITEMS:
      return ImmutableMap({
        initialized: true,
        items: ImmutableMap(action.items)
      });
    case UPDATE_FAKE_UNDOABLE_ITEMS:
      return state.update('items', items => items.merge(ImmutableMap(action.items)));
    default:
      return state;
  }
};
export default fakeUndoableReducer;